import {UPDATE_DATA} from '../types';
export const updatePermissions =(object)=>{
    return {
        type:UPDATE_DATA,
        payload : object
    }
}